import { filter, get, keys, some, values } from 'lodash'
import moment from 'moment'

import { TItemTable } from './types'
/**
 * Updates a sorts object.
 * @param {*} sorts
 * @param {*} key
 * @param {*} keep
 */

type TSort = {
  id: number
  key: string
  state: number | boolean
}

type TSorts = {
  [key: string]: TSort
}

export function updateSort(
  currentSorts: Array<TSort>,
  key: string,
  keep: boolean,
): TSorts {
  const existing = values(currentSorts).find((sort) => sort.key === key)
  let sorts: any
  if (!keep) {
    const sort = {
      id: 0,
      key,
      state: existing ? 1 - (existing.state ? 1 : 0) : 0,
    }
    sorts = {
      0: sort,
    }
  } else {
    let sort: TSort
    if (existing) {
      if (existing.id === 0) {
        // first sort, just flip state
        sort = {
          ...existing,
          state: 1 - (existing.state ? 1 : 0),
        }
      } else {
        // secondary sort: false->0, 0->1, 1->false (disabled)
        let state
        if (existing.state === false) {
          state = 0
        } else if (existing.state === 0) {
          state = 1
        } else if (existing.state === 1) {
          state = false
        }
        sort = {
          ...existing,
          state,
        }
      }
    } else {
      // not existing, add to end
      sort = {
        id: keys(currentSorts).length,
        key,
        state: 0,
      }
    }
    sorts = {
      ...currentSorts,
      [sort.id]: sort,
    }
  }
  return sorts
}

export const filterArray = (
  items: TItemTable[],
  fields: string[],
  value: string,
  fulltextConfig: {
    formatConfigs: any
  },
): any[] => {
  const newFields = Array.isArray(fields) ? fields : [fields]

  return filter(items, (item) =>
    some(newFields, (field) => {
      const formatConfigs = get(fulltextConfig, 'formatConfigs', {})

      if (get(formatConfigs, `${field}`) === 'date') {
        return (
          moment(item[field]).format('DD.MM.YYYY').indexOf(value.toString()) >
          -1
        )
      } else {
        return (
          item[field]
            .toString()
            .toLowerCase()
            .indexOf(value.toString().toLowerCase()) > -1
        )
      }
    }),
  )
}
